require('./bootstrap');

// Import modules...
import { createApp, h } from 'vue';
import { App as InertiaApp, plugin as InertiaPlugin, InertiaLink } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';
import FlashMessage from '@/Components/FlashMessage';
import mitt from 'mitt';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

import VueElementLoading from "vue-element-loading";

import SvgIcon from '@jamescoyle/vue-icon'


const emitter = mitt();

const options = {
    // You can set your default options here
};

const el = document.getElementById('app');

const app = createApp({
    data: function()
    {
        return {
            showMenu: true,
            showSearch: false,
            mainWidth: '700',

            // Card-Table view
            viewType: 'table', //delete

            // Farm search
            search : {
                organisation : {
                    search : '',
                    selected: null,
                    open: false,
                    organisations: {}
                },
                farmer : {
                    search : '',
                    selected: null,
                    open: '',
                    farmers: {}
                },
                organisation_id:  ''
            },

            // Task search
            task : {
                search : '',
                status: '',
                date: [],
                sort: '',
                sortingOrder: false,
                filter: '',
                user_filter: '',
                advisor:'',
                page: 1,
                contractor: ''
            },

            // Soil Analysis / Lab Test results search
            analysis : {
                search : '',
                farmer: '',
                page: 1,
            },

            // Farm object
            farmer: {
                user_filter: '',
                sort:'name',
                by: 'asc',
                zoom: true,
            },
            sampleZones: {},
            paths:{
                zoom: true,
                samples:[]
            },
            fields:{},

            showFarmManager:true,

            // Map on mobile
            showMapOnMobile: false,
            lpisLinking: false, // true while LPIS parcels are linked on the map; hides the map/list switch

            // Lpis
            Lpis:{
                show: false, // this is for showing the LPIS info on the map
                source: null, // "isec" for the ISEC herd layer, "dafm" for DAFM anonymous LPIS
                show_zone: true, // this is for showing the zone count 
                herdNo: '', 
                showLpisAreaDetails: true, // [true, false] for showing LPIS info and toggle
                filterCompletedHerdNo: false,
            },


            // arcgis features layer
            services:{
                dropoff_points: false,
                sampler_location: false
            },
        }
    },
    render: () =>
        h(InertiaApp, {
            initialPage: JSON.parse(el.dataset.page),
            resolveComponent: (name) => require(`./Pages/${name}`).default,
        })
    })
    .component('InertiaLink', InertiaLink)
    .component('FlashMessage', FlashMessage)
    .component("VueElementLoading", VueElementLoading)
    .component('svg-icon', SvgIcon)
    .mixin({ methods: { route }, mounted(){
        const removePreserveDataForComponents = ['farmerManger', 'organisationManager', 'usersManager','tasksManager', 'soilAnalysisManager', 'settingsManager', 'profileManager'];
        
        // reset some global data when any of this component is mounted
        if (removePreserveDataForComponents.includes(this.$options.name)) {

            emitter.emit('hideToggleCompleteHerds');

            this.$root.paths={zoom: true};
            this.$root.sampleZones = {};
            this.$root.paths={};
            this.$root.farmer = {};
            this.$root.Lpis = {
                show: false,
                source: null,
                show_zone : true,
                herdNo: '',
                showLpisAreaDetails: false,
                filterCompletedHerdNo: false,
            };   

            this.$root.services = {
                dropoff_points: false,
                sampler_location: false
            };
        }
    },  })
    .use(InertiaPlugin)
    .use(Toast, options);

    app.config.globalProperties.$emitter = emitter

    app.use(VueSweetalert2);
    app.mount(el)

InertiaProgress.init({ color: '#4B5563' });